import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "@/lib/api";
import { useCart } from "@/context/CartContext";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const [state, setState] = useState("checking");
  const { clear } = useCart();
  const sessionId = params.get("session_id");

  useEffect(() => {
    let tries = 0, timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setState("paid"); clear(); return; }
        if (["expired", "failed"].includes(data.payment_status)) return setState("failed");
      } catch { /* retry */ }
      if (++tries >= 15) return setState("timeout");
      timer = setTimeout(poll, 2000);
    };
    if (sessionId) poll(); else setState("failed");
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId]);

  const view = {
    checking: [Loader2, "Confirming payment", "Hang tight while we verify with Stripe...", "animate-spin text-neutral-400"],
    paid: [CheckCircle2, "Order confirmed", "Thanks for repping ABS. Your gear is on its way.", "text-emerald-400"],
    failed: [XCircle, "Payment failed", "Your payment didn't go through. Nothing was charged.", "text-[#FF3B30]"],
    timeout: [Loader2, "Still processing", "Check your orders page in a moment.", "text-[#FF9500]"],
  }[state];
  const [Icon, title, msg, cls] = view;

  return (
    <div className="max-w-xl mx-auto px-4 py-28 text-center rise" data-testid="payment-result">
      <Icon className={`w-16 h-16 mx-auto ${cls}`} />
      <h1 data-testid="payment-status-title" className="font-display font-black uppercase text-5xl mt-6">{title}</h1>
      <p className="text-neutral-400 mt-3">{msg}</p>
      <div className="flex gap-3 justify-center mt-10">
        <Link to="/orders" data-testid="view-orders-button" className="h-12 px-6 bg-[#FF3B30] hover:bg-[#E02E24] text-white font-display uppercase font-black tracking-wider grid place-items-center">View orders</Link>
        <Link to="/shop" data-testid="continue-shopping-button" className="h-12 px-6 border border-white/20 hover:bg-white hover:text-black font-display uppercase font-bold tracking-wider grid place-items-center">Keep shopping</Link>
      </div>
    </div>
  );
}
